import { render } from "./fr3_duo.vue?vue&type=template&id=da824bf6&scoped=true"
import script from "./fr3_duo.vue?vue&type=script&lang=js"
export * from "./fr3_duo.vue?vue&type=script&lang=js"

import "./fr3_duo.vue?vue&type=style&index=0&id=da824bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da824bf6"]])

export default __exports__